import { Navigate } from 'react-router';
import OnboardingFlow from '../components/onboarding/OnboardingFlow';
import HomeRoutes from './HomeRoutes';
import PageLayout from '../layouts/PageLayout';
import DashboardRoutes from './DashboardRoutes';
import FarmRoutes from './FarmRoutes';
import TeamRoutes from './TeamRoutes';

const AppRoutes = {
  path: 'app',
  children: [
    // Ensure that '/app' redirects to home
    { index: true, element: <Navigate to="my-projects" replace /> },
    { path: 'onboard', element: <OnboardingFlow /> },
    { element: <PageLayout />, children: [HomeRoutes, DashboardRoutes] },
    FarmRoutes,
    TeamRoutes,
  ],
};

export default AppRoutes;
